module.exports = __webpack_public_path__ + "static/media/image_placeholder.17fd58c3.jpg";